import * as _ from 'lodash';
import { api } from '@/core';
import { countryDic } from '@/core/country';
import { buildUserFormikConfig, IGuestRequest } from '@/pages/profile';

export const buildGuestFormikConfig = () => {
  return buildUserFormikConfig();
};

export const submitGuestForm = (appProfileId: string, values: any) => {
  const data = Object.assign(_.clone(values), {
    appProfileId,
    country: countryDic[values.country].name,
  }) as IGuestRequest;
  const endpoint = '/api/login-gate-guest-form';
  return api.post<any>(`${endpoint}`, data, {
    useGlobalLoading: true,
    responseType: 'text',
  });
};
